import React, { useEffect } from "react";
import { Box, Grid, Card, CardContent, Typography } from "@mui/material";
import { storeOrderDetailsAsync } from "redux/storePackage/storeProduct.async";
import { useDispatch, useSelector } from "react-redux";

function QuantityListIncrease({ packageInfo }) {
  const dispatch = useDispatch();
  const { getAllOrderById } = useSelector((state) => state.storeProduct);

  useEffect(() => {
    if (packageInfo?.id) {
      dispatch(
        storeOrderDetailsAsync({
          orderId: packageInfo?.id,
        }),
      );
    }
  }, [packageInfo?.id]);

  return (
    <Box sx={{ width: "100%", p: 2, pb: 4 }}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              border: "1px solid #E5E7EB",
              borderRadius: "10px",
              p: 2,
              height: "100%",
            }}
          >
            <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 1 }}>
              {getAllOrderById?.data?.length > 0 &&
                getAllOrderById?.data[0].user?.name}
            </Typography>
            <Box sx={{ display: "flex", alignItems: "flex-start", gap: 2 }}>
              <Typography variant="subtitle1" fontWeight={600}>
                Phone:
              </Typography>
              <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: 500,
                  color: "#111827",
                }}
              >
                {getAllOrderById?.data?.length > 0 &&
                  getAllOrderById?.data[0]?.user?.phone}
              </Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "flex-start", gap: 2 }}>
              <Typography variant="subtitle1" fontWeight={600}>
                Order Id:
              </Typography>
              <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: 500,
                  color: "#111827",
                }}
              >
                {getAllOrderById?.data?.length > 0 &&
                  getAllOrderById?.data[0]?.order_id}
              </Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "flex-start", gap: 2 }}>
              <Typography variant="subtitle1" fontWeight={600}>
                Order Status:
              </Typography>
              <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: 500,
                  color: "#111827",
                }}
              >
                {getAllOrderById?.data?.length > 0 &&
                  getAllOrderById?.data[0]?.order_status}
              </Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "flex-start", gap: 2 }}>
              <Typography variant="subtitle1" fontWeight={600}>
                Payment Status:{" "}
              </Typography>
              <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: 500,
                  color: "#111827",
                }}
              >
                {getAllOrderById?.data?.length > 0 &&
                  getAllOrderById?.data[0]?.payment_status}
              </Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "flex-start", gap: 2 }}>
              <Typography variant="subtitle1" fontWeight={600}>
                Total Amount:{" "}
              </Typography>
              <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: 500,
                  color: "#111827",
                }}
              >
                {getAllOrderById?.data?.length > 0 &&
                  getAllOrderById?.data[0]?.total_amount}
              </Typography>
            </Box>
          </Box>
        </Grid>

        <Grid item xs={12} md={6}>
          <Box
            sx={{
              border: "1px solid #E5E7EB",
              borderRadius: "10px",
              p: 2,
              height: "100%",
            }}
          >
            <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 1 }}>
              {getAllOrderById?.data?.length > 0 &&
                getAllOrderById?.data[0].userOrderAddress?.fullName}
            </Typography>

            <Box sx={{ display: "flex", alignItems: "flex-start", gap: 2 }}>
              <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 1 }}>
                Address:
              </Typography>
              <Box>
                <Typography variant="body2" color="text.secondary">
                  {getAllOrderById?.data?.length > 0 &&
                    getAllOrderById?.data[0].userOrderAddress?.address1}
                  <br />
                  {getAllOrderById?.data?.length > 0 &&
                    getAllOrderById?.data[0].userOrderAddress?.address2}
                  <br />
                  {getAllOrderById?.data?.length > 0 &&
                    getAllOrderById?.data[0].userOrderAddress?.storeUserCity
                      ?.name}
                  , &#160;
                  {getAllOrderById?.data?.length > 0 &&
                    getAllOrderById?.data[0].userOrderAddress?.storeUserState
                      ?.name}
                  ,{" "}
                  {getAllOrderById?.data?.length > 0 &&
                    getAllOrderById?.data[0].userOrderAddress?.pincode}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Grid>
      </Grid>

      <Grid container spacing={2} sx={{ mt: 1 }}>
        {getAllOrderById?.data?.length > 0 &&
          getAllOrderById?.data[0]?.items?.map((item) => (
            <Grid item xs={12} sm={6} key={item.id}>
              <Card
                elevation={0}
                sx={{
                  border: "1px solid #E5E7EB",
                  borderRadius: "12px",
                  transition: "box-shadow 0.2s",
                  "&:hover": {
                    boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                  },
                }}
              >
                <CardContent sx={{ p: 2 }}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "flex-start",
                      flexDirection: "column",
                    }}
                  >
                    <Box
                      sx={{ display: "flex", alignItems: "flex-start", gap: 2 }}
                    >
                      <Box sx={{ mb: 1 }}>
                        <img
                          src={item?.product_thumbnail}
                          alt=""
                          width="auto"
                          height="40px"
                        />
                      </Box>
                      <Typography
                        sx={{
                          fontSize: "14px",
                          fontWeight: 500,
                          color: "#111827",
                        }}
                      >
                        {item.product_title}
                      </Typography>
                    </Box>
                    <Box
                      sx={{ display: "flex", alignItems: "flex-start", gap: 2 }}
                    >
                      <Typography variant="subtitle1" fontWeight={600}>
                        Quantity:
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "14px",
                          fontWeight: 500,
                          color: "#111827",
                        }}
                      >
                        {item.quantity}
                      </Typography>
                    </Box>
                    <Box
                      sx={{ display: "flex", alignItems: "flex-start", gap: 2 }}
                    >
                      <Typography variant="subtitle1" fontWeight={600}>
                        Unit Price:
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "14px",
                          fontWeight: 500,
                          color: "#111827",
                        }}
                      >
                        {item.unit_price}
                      </Typography>
                    </Box>

                    <Box
                      sx={{ display: "flex", alignItems: "flex-start", gap: 2 }}
                    >
                      <Typography variant="subtitle1" fontWeight={600}>
                        Total Price:
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "14px",
                          fontWeight: 500,
                          color: "#111827",
                        }}
                      >
                        {item.total_price}
                      </Typography>
                    </Box>

                    <Box
                      sx={{ display: "flex", alignItems: "flex-start", gap: 2 }}
                    >
                      <Typography variant="subtitle1" fontWeight={600}>
                        Delivery Status:
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "14px",
                          fontWeight: 500,
                          color: "#111827",
                        }}
                      >
                        {item.delivery_status}
                      </Typography>
                    </Box>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
      </Grid>
    </Box>
  );
}

export default QuantityListIncrease;
